import { type FC } from 'react';
import classnames from 'classnames';

import { Button } from 'dibs-elements/exports/Button.tsx';
import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';

import { useTradeApplyHandler } from '../applyHandler/TradeApplyHandlerProvider.tsx';
import { trackTradeBenefitsEvent } from '../tradeBenefitsTracking.ts';

import styles from './TradeBenefitsApplyBanner.scss';
import dibsCss from 'dibs-css';

const TradeBenefitsApplyBanner: FC = () => {
    const applyHandler = useTradeApplyHandler();

    const handleApplyClick = (): void => {
        trackTradeBenefitsEvent({
            stepInteractionName: 'apply now clicked',
            trigger: 'creative vision',
        });
        applyHandler();
    };

    return (
        <div
            className={classnames(styles.container, dibsCss.pyXlarge, dibsCss.pxMedium)}
            data-tn="trade-benefits-apply-banner"
        >
            <div
                className={classnames(
                    styles.content,
                    dibsCss.maxW1440px,
                    dibsCss.my0,
                    dibsCss.mxAuto,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.flexCol,
                    dibsCss.gapMedium
                )}
            >
                <HeadingLevel>
                    {Heading => (
                        <Heading
                            className={classnames(
                                styles.title,
                                dibsCss.textCenter,
                                dibsCss.textHeaderBannerSmallNormal,
                                dibsCss.m0
                            )}
                        >
                            <FormattedMessage
                                id="abt.TradeBenefitsApplyBanner.title"
                                defaultMessage="Your Creative Vision{separator}<italic>Our Trade 1st Program</italic>"
                                values={{
                                    separator: (
                                        <>
                                            <span className={styles.desktopSeparator}> — </span>
                                            <span className={styles.mobileSeparator}>
                                                ,<br />
                                            </span>
                                        </>
                                    ),
                                    italic: content => (
                                        <span
                                            className={classnames(
                                                styles.titleItalic,
                                                dibsCss.sassyFontHeaderBannerSmallItalic
                                            )}
                                        >
                                            {content}
                                        </span>
                                    ),
                                }}
                            />
                        </Heading>
                    )}
                </HeadingLevel>
                <Button
                    onClick={handleApplyClick}
                    style="circle"
                    className={styles.button}
                    dataTn="trade-benefits-apply-now"
                >
                    <FormattedMessage
                        id="abt.TradeBenefitsApplyBanner.cta"
                        defaultMessage="Apply Now"
                    />
                </Button>
            </div>
        </div>
    );
};

export { TradeBenefitsApplyBanner };
